<template>
    <main>
        <DialogNewsModeration @updated="onUpdatedEvent" @openNext="moderateNext" ref="newsModDialog"/>
        <v-table
            id="clinicNewsTable"
            request-uri="news/getList"
            pagesize="50"
            ref="table"
        >
            <template v-slot:header>
                <v-tr>
                    <v-th name="clinicName" width="200">
                        Клиника
                    </v-th>
                    <v-th name="description" minwidth="200">
                        Описание
                    </v-th>
                    <v-th name="created" sort="created_at" width="85" highlight="*">
                        Добавлена
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="clinicName" :debounce="true" v-slot="{filter}" width="200">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="description" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="created" v-slot="{filter}">
                        <date-picker v-model="filter.value"/>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index, indexOnPage }">
                <v-tr :class="['hover', 'pointer', {'warning': !item.approved}]" @click="(row, event) => handleRowClick(event, row, item)">
                    <v-td name="clinicName" width="200">
                        <div v-for="clinic in item.clinics" :class="[{'warning': clinic.isModerationSource}]">
                            <div class="text-ellipsis">
                                {{clinic.name}}
                            </div>
                        </div>
                        <div v-for="network in item.networkModerationSources" class="warning">
                            <div class="text-ellipsis">
                                Сетевой Аккаунт ({{network.name}})
                            </div>
                        </div>
                    </v-td>
                    <v-td name="description">
                        <span class="max5LinesText" v-html="item.description" />
                    </v-td>
                    <v-td name="created" highlight="*">
                        {{ item.created_at | formatDate }}
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>
<script>
import DialogNewsModeration from './Dialog'
import DatePicker from "@base/DatePicker";
export default {
    components: {DialogNewsModeration, 'date-picker': DatePicker,},
    methods: {
        onUpdatedEvent (){
            this.$refs.table.update();
        },
        handleRowClick(event, row, item) {
            row.startLoadingAnimation();
            this.$refs.newsModDialog
                .showModal(item.id)
                .then(() => row.stopLoadingAnimation())
                .catch(() => row.stopLoadingAnimation());
        },
        moderateNext(newsId) {
            setTimeout(async () => {
                let previousNewsId = newsId;
                let row, index;

                for (const i in this.$refs.table.rows) {
                    index = parseInt(i);
                    row = this.$refs.table.rows[index];

                    if (row.id === previousNewsId && this.$refs.table.rows[index + 1] && this.$refs.table.rows[index + 1].id) {
                        await this.axios.get('/admin/moderation/news/' + this.$refs.table.rows[index + 1].id + '/isOpened')
                            .then(data => {
                                if (data.data.success) {
                                    const nextRow = document.querySelectorAll('#clinicNewsTable table tbody tr.table-row')[index + 1];
                                    if (nextRow) {
                                        nextRow.click();
                                    }
                                }else {
                                    previousNewsId = this.$refs.table.rows[index + 1].id;
                                }
                            })
                    }
                }

                this.$refs.table.update();
            }, 1000);
        },
    }
}

</script>
<style lang="scss">
#clinicNewsTable span.max5LinesText {
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;

    & p{
        margin: 0;
    }
}
</style>
